module.exports = __webpack_public_path__ + "src/assets/img/usb_01_en.f99660ba.png";